import { buttonVariants } from '@cocoonspace/ui/components/button'
import { HeaderIcon } from '@cocoonspace/ui/components/header-icon'
import { useLingui } from '@lingui/react/macro'
import { CalendarIcon } from 'lucide-react'
import { LocalizedLink as Link } from '~/components/localized-link'
import { usePathname } from 'next/navigation'

import { stripLocaleFromPath } from '~/i18n/routing'

export const NoEventsMsg = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const { t } = useLingui()

	return (
		<div className='flex flex-col items-center gap-4 py-16 text-center'>
			<HeaderIcon>
				<CalendarIcon />
			</HeaderIcon>

			<p className='text-lg font-semibold'>
				{pathname === '/events/past'
					? t`Vous n'avez pas encore réservé de Cocoon`
					: t`Vous n'avez pas d'évènements prévus`}
			</p>

			<Link
				className={buttonVariants({ variant: 'outline' })}
				href='/paris'
			>
				{t`Voir les Cocoons`}
			</Link>
		</div>
	)
}
